export default "__VITE_ASSET__Bvqur4K1__"